export default __webpack_public_path__ + "static/media/IMG_7999.c46bc9d9.jpeg";